/**
 * Formats a date string in the format YYYY-MM-DD to MM/DD/YY
 * @param date  date string in the format YYYY-MM-DD
 * @param dateFormat  formats the date to a date-fns format
 * @param undefinedBehavior  string to return if date is undefined or not in the expected format
 * @returns  date string in the format MM/DD/YY
 * @example
 * formatISODateString('2022-12-31') // returns '12/31/22'
 */
import { format } from 'date-fns';
/**
 * Standard display date format (date-fns pattern) used across the app for consistency.
 * Use with date-fns format(): format(date, DISPLAY_DATE_FORMAT)
 */
export const DISPLAY_DATE_FORMAT = 'MM/dd/yyyy';
export const formatISODateString = (date, dateFormat = 'MM/dd/yy', undefinedBehavior = 'Unknown') => {
    if (!date)
        return undefinedBehavior;
    // const dateArr = date.split('-');
    // if (dateArr.length !== 3) return undefinedBehavior; // check if date is in the expected format
    // const year = dateArr[0];
    // const month = dateArr[1];
    // const day = dateArr[2];
    try {
        // Replace all hyphens with slashes
        const formattedDate = date.replace(/-/g, '/');
        return format(new Date(formattedDate), dateFormat); // returns '12/31/2022
    }
    catch (e) {
        return undefinedBehavior;
    }
    // return `${month}/${day}/${year[2]}${year[3]}`;
};
export const formatDateToYYYYMMDD = (date) => {
    try {
        return format(new Date(date), 'yyyy-MM-dd');
    }
    catch (e) {
        return undefined;
    }
};
//# sourceMappingURL=date-formatter.js.map